export default {
  doNotCall: 'Do Not Call',
} as const;
